import {NotificationRepository} from "@api/repositories/NotificationRepository";
import {UserRepository} from "@api/repositories/UserRepository";
import {RepositoryFabric} from "@api/repositories/RepositoryFabric";
import {NotificationUpdates} from "@api/models/notifications/NotificationUpdates";
import {UserProfile} from "@api/models/UserProfile";
import Vue from 'vue';
import {RealtimeRepository} from "@api/repositories/reatime-repository/RealtimeRepository";

export class NotificationDataHelper {
    notificationRepository: NotificationRepository;
    userRepository: UserRepository;
    realtimeRepository: RealtimeRepository;
    updates: NotificationUpdates;
    profiles: Array<UserProfile>;
    unreadCount = 0;
    loading = false;

    constructor(repositories: RepositoryFabric) {
        this.notificationRepository = repositories.get(RepositoryFabric.NOTIFICATION);
        this.userRepository = repositories.get(RepositoryFabric.USER);
        this.realtimeRepository = repositories.get(RepositoryFabric.REALTIME);
    }

    async fetchUnread() {
        Vue.set(this, 'updates', await this.notificationRepository.updates());
        return this.updates.updated.filter(notification => !notification.isRead);
    }

    async loadList() {
        this.loading = true;

        const loadedUpdates = await this.notificationRepository.updates(),
                userIds = loadedUpdates.userIds();
        let profiles: Record<number,UserProfile> = {};

        if (userIds) {
            const fetchedProfiles = await this.userRepository.profiles({
                where: {
                    userId: {
                        $in: userIds
                    }
                },
                include: ['id', 'userId', 'firstName', 'lastName', 'photoFileId']
            });
            profiles = fetchedProfiles.reduce((profiles: Record<number,UserProfile>, profile: UserProfile) => (profiles[profile.userId as number] = profile, profiles), {});
        }

        Vue.set(this, 'profiles', profiles);
        Vue.set(this, 'updates', loadedUpdates);

        this.loading = false;

        this.markAsRead();
    }

    async fetchUnreadCount() {
        Vue.set(this, 'unreadCount', await this.notificationRepository.count());
    }

    async markAsRead() {
        this.unreadCount = await this.notificationRepository.markAsRead(this.updates.updatedAt, '');
    }

    async markAsReadById(id: string) {
        await this.notificationRepository.markAsReadById(id);
    }

    async markAsReadByDeepLink(deepLink: string) {
        await this.notificationRepository.markAsReadByDeepLink(deepLink);
    }
}
